import { render, staticRenderFns } from "./TabCoating.vue?vue&type=template&id=019341cc&"
import script from "./TabCoating.vue?vue&type=script&lang=ts&"
export * from "./TabCoating.vue?vue&type=script&lang=ts&"
import style0 from "./TabCoating.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports